import "./OnScreenKeyboard.css";

const ROWS = ["1234567890", "qwertyuiop", "asdfghjkl", "zxcvbnm"];

export interface OnScreenKeyboardProps {
  onKey: (char: string) => void;
  onBackspace: () => void;
  onSpace: () => void;
  onClear: () => void;
}

/** A kiosk has no physical keyboard — this is how a punter types a search term. */
export function OnScreenKeyboard(props: OnScreenKeyboardProps): React.JSX.Element {
  return (
    <div className="kbd">
      {ROWS.map((row, i) => (
        <div className="kbd__row" key={i}>
          {row.split("").map((char) => (
            <button key={char} className="kbd__key" onClick={() => props.onKey(char)}>
              {char}
            </button>
          ))}
        </div>
      ))}
      <div className="kbd__row">
        <button className="kbd__key kbd__key--wide" onClick={props.onClear}>
          Clear
        </button>
        <button className="kbd__key kbd__key--space" onClick={props.onSpace}>
          Space
        </button>
        <button className="kbd__key kbd__key--wide" onClick={props.onBackspace}>
          ⌫
        </button>
      </div>
    </div>
  );
}
